/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";

function ListImage (props) {
    
    const { image } = props;
    const width = 220;
    // const height = 194
    const { alt, title, url } = image || {};

    return (
        <Fragment>
            {image && (
                <div>
                    <img
                        alt={alt}
                        title={title}
                        width={width}
                        src={url}
                    />
                </div>
            )}
        </Fragment>
    );
}

export { ListImage };
